export const CREATE_ATTENDANCE = "CREATE_ATTENDANCE";
export const FETCH_ATTENDANCES = "FETCH_ATTENDANCES";
export const FETCH_ATTENDANCE = "FETCH_ATTENDANCE";
export const EDIT_ATTENDANCE = "EDIT_ATTENDANCE";
export const DELETE_ATTENDANCE = "DELETE_ATTENDANCE";
export const UPDATE_ATTENDANCE_HEADER = "UPDATE_ATTENDANCE_HEADER";
